import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

interface SortIndicatorProps {
  column: string;
  sortConfig: {
    column: string | null;
    direction: 'asc' | 'desc';
  };
}

export const SortIndicator = ({ column, sortConfig }: SortIndicatorProps) => {
  if (sortConfig.column !== column) {
    return <ArrowUpDown className="h-4 w-4 text-gray-400" />;
  }

  return sortConfig.direction === 'asc'
    ? <ArrowUp className="h-4 w-4 text-blue-600" />
    : <ArrowDown className="h-4 w-4 text-blue-600" />;
};
